import { render, staticRenderFns } from "./new-year-activity.vue?vue&type=template&id=232e3028&scoped=true&"
import script from "./new-year-activity.vue?vue&type=script&lang=js&"
export * from "./new-year-activity.vue?vue&type=script&lang=js&"
import style0 from "./new-year-activity.vue?vue&type=style&index=0&id=232e3028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232e3028",
  null
  
)

export default component.exports